import { apiService } from './api';

export interface UsuarioPerfilEntidadeRequest {
    usuarioId: string;
    perfilId: number;
    entidadeId: string;
    status?: string;
    areaIds?: string[];
}

export interface UsuarioPerfilEntidadeResponse {
    // Empty interface since the endpoint returns void
}

export interface UsuarioAcessoResponse {
    usuarioPerfilEntidadeId: number;
    usuarioId: string;
    usuarioNome: string;
    usuarioEmail: string;
    perfilId: number;
    perfilNome: string;
    entidadeId: string;
    entidadeNome: string;
    dtCriacao: string;
    criadoPor: string;
    status?: string; // Status of the user profile entity association
}

export interface UsuarioAcessoAreaResponse {
    entidadeId: string;
    areaId: string;
    areaNome: string;
    status?: string; // Status of the user area access
}

class UserProfileService {
    private readonly baseUrl = '/usuario-perfil';

    /**
     * Creates a new user profile entity association
     * @param request - The user profile entity request data
     * @returns Promise that resolves when the creation is successful
     */
    async criarUsuarioPerfilEntidade(request: UsuarioPerfilEntidadeRequest): Promise<void> {
        try {
            await apiService.post(this.baseUrl, request);
        } catch (error) {
            console.error('Error creating user profile entity:', error);
            throw error;
        }
    }

    /**
     * Fetches user access data for a specific user
     * @param userId - The UUID of the user
     * @returns Promise that resolves with the list of user access data
     */
    async listarAcessoUsuario(userId: string): Promise<UsuarioAcessoResponse[]> {
        try {
            const response = await apiService.get(`${this.baseUrl}/usuario/${userId}`);
            return response;
        } catch (error) {
            console.error('Error fetching user access data:', error);
            throw error;
        }
    }

    /**
     * Fetches user area access data for a specific user
     * @param userId - The UUID of the user
     * @returns Promise that resolves with the list of user area access data
     */
    async listarAcessoAreaUsuario(userId: string): Promise<UsuarioAcessoAreaResponse[]> {
        try {
            const response = await apiService.get(`${this.baseUrl}/usuario/${userId}/areas`);
            return response;
        } catch (error) {
            console.error('Error fetching user area access data:', error);
            throw error;
        }
    }

    /**
     * Removes user profile entity association
     * @param usuarioPerfilEntidadeId - The ID of the user profile entity association
     * @returns Promise that resolves when the deletion is successful
     */
    async removerUsuarioPerfilEntidade(usuarioPerfilEntidadeId: number): Promise<void> {
        try {
            await apiService.delete(`${this.baseUrl}/${usuarioPerfilEntidadeId}`);
        } catch (error) {
            console.error('Error removing user profile entity:', error);
            throw error;
        }
    }
}

// Export a singleton instance
export const userProfileService = new UserProfileService();
